<!-- <app-header-one [sticky]="true"></app-header-one> -->
<!-- <app-header-one [sticky]="true"></app-header-one> -->
<app-header-latest></app-header-latest>

<section class="terms-popup">
  <div class="popup-container">
    <div class="popup-card">

      <h1 style="text-align: center;">Cancellation Policy</h1>

      <p><strong>Last Updated:</strong> 12th June, 2026</p>

      <h2>1. Subscription Cancellation</h2>

      <p>
        <strong>•</strong> You can cancel your subscription at any time. Navigate to
        <strong>Settings</strong>, select <strong>Subscription</strong>, and choose
        <strong>"Cancel Subscription"</strong>.
      </p>

      <p>
        <strong>•</strong> Cancellation must be done at least 24 hours before the end
        of the current billing cycle to avoid auto-renewal.
      </p>

      <h2>2. Effect of Cancellation</h2>

      <p>
        <strong>•</strong> Upon cancellation, you will lose access to premium features
        like direct messaging, profile boosts, or contact details after the subscription ends.
      </p>

      <p>
        <strong>•</strong> No refunds are issued for unused portions of your subscription
        period unless required by applicable law.
      </p>

      <h2>3. Job Application Cancellation</h2>

      <p>
        <strong>•</strong> Once a job application is submitted, it cannot be cancelled
        or withdrawn via the App. Contact the recruiter directly for application withdrawal,
        if necessary.
      </p>

      <p>
        <strong>•</strong> If you mistakenly apply for a job, please email us at
        <a href="mailto:support@neojobz.com">support&#64;neojobz.com</a>
        for guidance.
      </p>

      <h2>4. Refund Policy</h2>

      <p>
        <strong>•</strong> Refunds for subscriptions or purchases are managed by NeoJobz.
        If eligible, request a refund through the NeoJobz Support Team.
      </p>

      <p>
        <strong>•</strong> Refund eligibility is subject to NeoJobz's refund policies.
      </p>

      <h2>Contact Information for NeoJobz Services</h2>

            <p>
            •	For questions or concerns about cancellations, contact us at:
            </p>

            <p>
                <strong>By email:</strong>
                <a href="mailto:support@neojobz.com">
                    support&#64;neojobz.com
                </a>
            </p>

            <p>
                <strong>By phone number:</strong>
                +91-70 75 74 5784
            </p>

            <p>
                •	Review our Terms & Conditions and Privacy Policy for further details.
            </p>
    </div>
  </div>
</section>

<app-footer-more-info></app-footer-more-info>
            <!-- <h2 class="title" >{{tncData.title}}</h2>
            <div [innerHTML]="tncData.description"></div>
          </div> -->
          
        <!-- <div class="popup-card">
            <h2 class="title" style="cursor: pointer;">Cancellation Policy</h2>
            <h3 style="text-align: center;">[Employment and Matrimonial Services]</h3>
    
    <p><strong>Effective Date:</strong> 15-Dec-2024 <span style="float: right;"><strong>Last Updated:</strong> 05-Feb-2025</span></p>
     <h2>1. Subscription Cancellation</h2>
    <ul>
               &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li>•	You can cancel your subscription at any time. Navigate to  <strong>Settings > Your Name > Subscriptions</strong>, select, and choose “Cancel Subscription.”</li><br><br>
               &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<li>•	Cancellation must be done at least  <strong>24 hours before the end of the current billing cycle</strong> to avoid auto-renewal.</li><br><br>
    </ul>
    
    <h2>2. Effect of Cancellation</h2>
    <ul>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li>•	Upon cancellation, you will lose access to premium features like direct messaging, profile boosts, or contact details after the subscription ends.</li><br><br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li>•	No refunds are issued for unused portions of your subscription period unless required by applicable law.</li><br><br>
</ul>
    <h2>3. Job Application Cancellation</h2>
    <ul>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li>•	Once a job application is submitted, it cannot be cancelled or withdrawn via the App. Contact the recruiter directly for application withdrawal if necessary.</li><br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<li>•	If you mistakenly apply for a job, please email us at  <a href="mailto:support@whiterobe.in">support&#64;whiterobe.in</a> for guidance.</li><br><br>
    </ul>

    <h2>4. Matrimonial Profile Deletion</h2>
    <ul>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  <li>•	Deleting your profile will automatically cancel your subscription. Ensure you cancel your subscription through your App to stop future payments.</li><br><br>
    </ul>
    
    <h2>5. Refund Policy</h2>
    <ul>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li>•	Refunds for subscriptions or purchases are managed by WhiteRobe. If eligible, request a refund through WhiteRobe Support Team.</li>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<li>•	Refund eligibility is subject to WhiteRobe’s refund policies.</li><br><br>
    </ul>
    
    <h2>Contact Information for Both Jobs and Matrimonial Services</h2>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <p>•	For questions or concerns about cancellations, contact us at:</p>
    <ul >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li><strong><i class="fa fa-envelope-o"></i>	Email:</strong> <a href="mailto:supportwhiterobe.in"> support&#64;whiterobe.in</a></li><br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li><strong><i class="fa fa-phone"></i>	Phone:</strong> +91-70 75 85 5784</li><br>
    </ul>

    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <p>•	Review our  <a (click)="goTo('/terms-and-conditions')">Terms & Conditions</a> and <a (click)="goTo('/privacy')">Privacy Policy</a> for further details.</p>
</div> -->



    <!-- <app-footer-one></app-footer-one> -->
